import { accessToken } from '../helpers';
import { loopbackConstants } from '../constants';

export const devicetypeService = {
    getAll
};

function getAll() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(loopbackConstants.BASE_URL+'/archive/devicetypes'+accessToken('archive'), requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) { 
        return Promise.reject(response);
    }
    return response.json();
}




// WEBPACK FOOTER //
// ./src/services/devicetype.service.js